import React, { useState } from "react";
import { Upload } from "lucide-react";

export default function AdminProofUpload({ schools, onUpload }) {
  const [schoolId, setSchoolId] = useState("");
  const [file, setFile] = useState(null);
  const [caption, setCaption] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!schoolId || !file) return;
    setBusy(true);
    await onUpload(schoolId, file, caption);
    setBusy(false);
    setFile(null);
    setCaption("");
    e.target.reset?.();
  };

  return (
    <form onSubmit={submit} className="bb-card p-6" data-testid="admin-proof-upload">
      <div className="bb-overline text-[var(--bb-muted)] mb-3 flex items-center gap-2">
        <Upload size={14} /> UPLOAD PROOF ON BEHALF OF A SCHOOL
      </div>
      <p className="text-xs text-[var(--bb-muted)] mb-4">Select a school, attach a photo/video (≤ 2MB). Admin uploads are auto-approved.</p>
      <div className="grid md:grid-cols-4 gap-3 items-end">
        <div>
          <label className="bb-overline text-[var(--bb-muted)]">School</label>
          <select required value={schoolId} onChange={(e) => setSchoolId(e.target.value)} className="mt-2 w-full bg-transparent border-b border-[var(--bb-border)] py-2 outline-none focus:border-[var(--bb-terracotta)] text-sm" data-testid="admin-proof-school">
            <option value="">Choose a school…</option>
            {schools.map((s) => (<option key={s.school_id} value={s.school_id}>{s.name}</option>))}
          </select>
        </div>
        <div>
          <label className="bb-overline text-[var(--bb-muted)]">File</label>
          <input required type="file" accept="image/*,video/*" onChange={(e) => setFile(e.target.files[0])} className="mt-2 w-full text-xs" data-testid="admin-proof-file" />
        </div>
        <div>
          <label className="bb-overline text-[var(--bb-muted)]">Caption (optional)</label>
          <input type="text" value={caption} onChange={(e) => setCaption(e.target.value)} className="mt-2 w-full bg-transparent border-b border-[var(--bb-border)] py-2 outline-none focus:border-[var(--bb-terracotta)] text-sm" data-testid="admin-proof-caption" />
        </div>
        <button type="submit" disabled={busy || !schoolId || !file} className="bb-btn-primary text-sm" data-testid="admin-proof-submit">{busy ? "Uploading…" : "Upload"}</button>
      </div>
    </form>
  );
}
